import React, { useState, useContext, useEffect } from "react";
import "../../../styles/casedetails.css";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import { ShareContext } from "../../../context/ShareContext";
import * as Constants from "../../../constants";
import JisButton from "../../controls/jisButton";
import DynamicIcon from "../../dynamicicon";
import JisDialogForm from "../../formdialog";
import PdfViewer from "../../controls/pdfviewer";
import { useStepContext } from "@mui/material";
import BackLoader from "../../backloader";

function ViewDocuments({ caseId, documents,filingtype=1, isAction = false }) {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData } = useContext(ShareContext);
  const [loading, setLoading] = useState(false);
    const [isPreview, setIsPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(false);
  const [openSettlement, setOpenSettlement] = useState(false);
  const [signatureCount, setSignatureCount] =useState(1);
  const [settlementCost, setSettlementCost] = useState(0);
  const [signatureCost, setSignatureCost] = useState(0);
  const [config, setConfig] =useState([]);
  const [isLoading, setIsLoading] = useState(false);
const [isSuccess, setIsSuccess] = useState(false);
console.log("here is the documents "+ isAction);
  const onFilingDocument = () => {
    navigate(`/filing-document/${caseId}`);
  };
const onFileSettlement = () => {
    //navigate(`/filing-document/${caseId}`);
    setOpenSettlement(true)
  };
  const onConfig = async () => {
    const urls = `${Constants.apiUrl}/setup/otherpayitems/settlement`;
    console.log(`the calling url ${urls}`);

    try {
      const resp = await fetch(urls, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setConfig(data);
    } catch (error) {
      console.error(error);
    }
  };
  const onDownload = async (doc) => {
    //doctype=upline always this one
    //for account registration DocumentView
    const url = `${Constants.apiUrl}/filing/downloadcasedocument/${doc.id}`;

    console.log(`the calling url ${url}`);
    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          responseType: "blob",
        },
      });

      const data = await resp.blob();
      setLoading(false);
      console.log("specific document");
      const blob = new Blob([data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.download = doc.filename; // 'some.pdf';
      link.href = URL.createObjectURL(blob);
      link.click();
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onPreviewDoc = (docs) => {
    setIsPreview(true);
    console.log(docs);
    console.log("here is called");
    var finalpath = "";
    if (docs.documentLocation != 'template') {
      finalpath = Constants.RelativeFiletoRelative(
        Constants.getDocumentPath(docs)
      );
    } else {
      finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
    }
    setPreviewUrl(finalpath);
  };
  const onPrintDoc = (docs) => {
    const  finalpath = `${Constants.baseurl}/template-live-document/${docs.id}`;
      window.location=finalpath;
  };

  useEffect(() => {

      onConfig();
    }, []);
    useEffect(() => {
        if (config.length > 0) {
          const aff = config.find((d) => d.code == "settlement-main");
          if (aff) {
            setSettlementCost(aff.fee);
          }
          const affex = config.find((d) => d.code == "settlement-signature");
          if (affex) {
            setSignatureCost(affex.fee);
          }
        }
      }, [config]);



   const onSettlementProceed = async () => {
      /*  console.log(revisedreason);
          return; */
     
    
  
      const term1084={gazettelineid:filingtype==2?   Constants.SettleGazetteLine_ADR :Constants.SettleGazetteLine,
        qty: 1,
        perItem: settlementCost,
        isUpload: true,
        itemType: 'External',}
      const sign1085={gazettelineid:filingtype==2?  Constants.SignatureGazetteLine_ADR :Constants.SignatureGazetteLine,
        qty: signatureCount,
        perItem: signatureCost,
        isUpload: false,
        itemType: 'External',};    
      
      const caseFeeLines =[term1084,sign1085];
      //var  =
      var rdata = {
        caseFeeLines,
        CaseFeeId: null,
        feetypeid: 33,
        revisedreason: "",
        source: "",
        sourceid:"",
        DocMoves: [],
      };
  
      console.log(JSON.stringify(rdata));
      try {
        setIsLoading(true);
        const resp = await fetch(
          `${Constants.apiUrl}/filing/process-gazette/${caseId}`,
          {
            method: "POST",
            body: JSON.stringify(rdata),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
  
        const responseData = await resp.json();
        setIsLoading(false);
        console.log(responseData);
        if (responseData.code === 0) {
        
          const fee = {
            amount: (settlementCost+(signatureCount*signatureCost)),
            feeid: responseData.id,
            isPaid: responseData.isPaid,
          };
          //internalFee, ExternalFee , Fee
          onGazetteProceed(fee);
        } else {
          alert(responseData.status);
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
      }
    };
const onGazetteProceed = (e) => {
    console.log("after processing... here is value");
    console.log(e);
   // setcasefeeId(e.feeid);
    setIsSuccess(e.isPaid);
    if(!e.isPaid){
      navigate(`/payment/${e.feeid}`)
    }
    
    
  };

  return (
    <div>
      {isAction && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{display:'flex', width:'fit-content', gap: '10px'}}>
            <button
              className="btn-solid add-addition-document-btn"
              onClick={onFilingDocument}
            >
              Add Additional Document
            </button>
            <button
              className="btn-solid add-addition-document-btn"
              onClick={onFileSettlement}
            >
              File Terms of Settlement
            </button>
          </div>
          
        </div>
      )}

      <div className="table">
        <div class="table-header">
          <p>Case Documents</p>
        </div>

        <div className="table-wrapper">
          <table className="case-details-table full-border">
            <thead>
              <tr>
                <th className="col-title">Title</th>

                <th>Party</th>
                <th>Filed On</th>
                <th className="col-action">Action</th>
                <th className="col-action">Download</th> 
              </tr>
            </thead>
            <tbody>
              {documents?.map((opt) => (
                <tr>
                  <td>{opt.title || "N/A"}</td>

                  {opt.party != null ? (
                    <td>
                      {" "}
                      {opt.party?.firstName || opt.party?.lastName
                        ? `${opt.party?.firstName} ${opt.party?.lastName ?? ""}`
                        : "N/A"}
                    </td>
                  ) : (
                    <td>
                      {opt.doneBy?.firstName || opt.doneBy?.lastName
                        ? `${opt.doneBy?.firstName} ${
                            opt.doneBy?.lastName ?? ""
                          }`
                        : "N/A"}
                    </td>
                  )}
                  <td>
                    {opt.createdOn
                      ? Constants.momentDate(opt.createdOn).format(
                          "DD MMM, YYYY"
                        )
                      : "N/A"}
                  </td>
                  
                  <td>
                    <JisButton
                      variant="plain"
                      onClick={() => onPreviewDoc(opt)}
                    >
                      Preview
                    </JisButton>
                  </td>
                  <td>
                   {opt.documentLocation != 'template' && <JisButton
                      variant="plain"
                      onClick={() => onDownload(opt)}
                    >
                      Download
                    </JisButton>} 
                    {opt.documentLocation == 'template' && <JisButton
                      variant="plain"
                      onClick={() => onPrintDoc(opt)}
                    >
                      Print/Save
                    </JisButton>} 
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
<BackLoader open={loading} />
      {isPreview && previewUrl != "" && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsPreview(false)}
        >
          <div>
            <div style={{ height: "90vh" }}>
              {" "}
              <PdfViewer pdfUrl={previewUrl} />
            </div>
          </div>
        </JisDialogForm>
      )}
     {openSettlement  && (
        <JisDialogForm
          title="File Term of Settlement"
          onClose={() => setOpenSettlement(false)}
        >
           <div className="affidavit-option-dialog">
            <div>
              <h3 className="affidavit-document-title">
                Term of Settlement cost {Constants.formatCurrency(settlementCost)}
              </h3>

              
              <div className="input-group">
                  <label> How many Signature?</label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="save" />
                    <input
                      placeholder="Signature Count"
                      type="number"
                      required={true}
                      name="setSignatureCount"
                      value={signatureCount}
                      min={1}
                      onChange={(e) => setSignatureCount(e.target.value)}
                    />
                  </div>
                </div>
              
            </div>
            
            <div className="exhibit-amount-payable">
              <span>Amount Payable:</span>{" "}
              <span>N {Constants.formatCurrency(settlementCost+(signatureCount*signatureCost))}</span>
            </div>
            <button className="exhibit-button" onClick={onSettlementProceed}>
              Process
            </button>
          </div>


        </JisDialogForm>
      )} 
    </div>
  );
}

export default ViewDocuments;
